/**
 * Centralized field descriptions for journey configuration fields.
 *
 * These descriptions are used as tooltip/info text across the platform —
 * both in configuration editors and read-only summary views. Any time a
 * journey field needs a user-facing explanation, it should be sourced
 * from this file so the copy stays consistent.
 *
 * For descriptions that vary by catalog item type, use the function form
 * and pass the relevant item type string.
 */

export const JOURNEY_FIELD_DESCRIPTIONS = {
    /** Delivery section */
    dateRange:
        'The start and end dates for this journey. "Ongoing" means no scheduled end date.',
    entryTrigger:
        'The event or condition that causes a subscriber to enter this journey.',
    quietHours:
        "Time window during which no messages will be sent to subscribers in this journey. Quiet hours run in each subscriber's local time zone (STZ).",
    frequencyCap:
        'Limits how many times a subscriber can enter this journey within a given time period.',

    /** Behavior section */
    endBehavior:
        'Controls what happens to in-flight subscribers when the journey ends. "Bleed" lets them finish naturally; "Stop" exits them immediately with the chosen status.',
    abandonmentWindow:
        'The duration of inactivity required before a subscriber qualifies for this journey.',

    /** Abandonment editor — dynamic descriptions keyed by item type */
    abandonmentTimeframe: (itemTypeSingular: string) =>
        `A subscriber will qualify for this journey after they have carted at least one ${itemTypeSingular} and not been active for the specified amount of time.`,
    browseAbandonmentEligibility:
        'Prevents a subscriber from entering a browse abandonment journey immediately after participating in a cart abandonment journey.',
    minimumItemViews: (itemTypeSingular: string) =>
        `The subscriber must view the same ${itemTypeSingular} at least the specified number times to qualify for the journey.`,
    maximumItemAge: (actionString: string, itemTypePlural: string) =>
        `${actionString} ${itemTypePlural} older than the specified number of days are excluded from this journey.`,
} as const
